export default __webpack_public_path__ + "static/1.2_DE-5539d71c9596bd4bf3b12cac92f4c97c.webp";